import { useQuery } from "react-query";
import { OrderTemplate } from "../models";
import { IOrderTemplate } from "../types";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { listOrderTemplates } from "../data/api/orderTemplates";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace order templates, read through the REST API. Mirrors `useProducts`:
 * query key + cache-key invalidation and `OrderTemplate[]` instance return
 * shape, so `updateCacheKey()` refreshes it after writes.
 */
const useOrderTemplates = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<OrderTemplate[], Error>(
    queryKeys.orderTemplates(cacheKey, resolvedWorkspaceId),
    async () => {
      const templates = await listOrderTemplates(
        token as string,
        resolvedWorkspaceId,
      );
      return templates.map(
        (template: IOrderTemplate) => new OrderTemplate(template),
      );
    },
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
    },
  );
};

export default useOrderTemplates;
